'use client';

import { Icon } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { BREAKPOINTS, getStoreDisplayTime, storeIsOpen, useStore, useWindowSize } from '@libs/common-next';

import './Location.scss';

export default function Location() {
    const { selectedStore } = useStore();
    const { data: store } = selectedStore;
    const size = useWindowSize();
    const classes = cn('location-icon', 'sparky-u-margin-right-xs', {
        'sparky-u-margin-left-md': size > BREAKPOINTS.lg,
    });

    if (!store) {
        return null;
    }

    const timezonedDate = new Date().toLocaleString('en', {
        timeZone: store.TimeZone?.TimeZoneId,
    });

    // date we are comparing to uses the timezone of the store we are using
    const currentDate = new Date(timezonedDate);

    const locationClassName = cn(
        'location-status',
        storeIsOpen(store, currentDate) ? 'location-open' : 'location-closed'
    );

    return (
        <div data-testid="location" className="location">
            <div className="location-section">
                <div className="location-status-block">
                    <Icon className={classes} size="sm" name="pin-outline" />
                    {store && <span className="location-name">{store?.Name}</span>}
                </div>
                {store && <span className={locationClassName}>{getStoreDisplayTime(store, currentDate)}</span>}
            </div>
        </div>
    );
}
